import React, { useState, useEffect } from 'react';
import { LngLat } from 'maplibre-gl';
import '../styles/Navigation.css';
import { FaArrowUp, FaArrowRight, FaArrowLeft } from 'react-icons/fa';

const maneuverToIcon = {
    'DEPART': FaArrowUp,
    'TURN_RIGHT': FaArrowRight,
    'TURN_LEFT': FaArrowLeft,
    'TURN_SLIGHT_LEFT': FaArrowLeft,
    'TURN_SLIGHT_RIGHT': FaArrowRight,
    'STRAIGHT': FaArrowUp,
};

const distanceMeters = (a, b) =>
    new LngLat(a.lng, a.lat).distanceTo(new LngLat(b.lng, b.lat));

const Navigation = ({ route, userLocation, handlePlaceCardClick, placesOnRoute }) => {
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [playedStories, setPlayedStories] = useState(new Set());
    const currentStep = route.navigation_steps[currentStepIndex];

    useEffect(() => {
        if (userLocation && route && route.navigation_steps) {
            const nextStep = route.navigation_steps[currentStepIndex + 1];
            if (nextStep) {
                const distance = distanceMeters(
                    userLocation,
                    { lat: nextStep.start.latitude, lng: nextStep.start.longitude }
                );

                if (distance < 20) { // 20 meters threshold
                    setCurrentStepIndex(currentStepIndex + 1);
                }
            }
        }

        if (userLocation && placesOnRoute) {
            placesOnRoute.forEach(place => {
                if (place && place.location) {
                    const distance = distanceMeters(
                        userLocation,
                        { lat: place.location.latitude, lng: place.location.longitude }
                    );

                    if (distance < 15 && !playedStories.has(place.reference)) {
                        handlePlaceCardClick(place, true);
                        setPlayedStories(prevPlayedStories => new Set(prevPlayedStories).add(place.reference));
                    }
                }
            });
        }
    }, [userLocation, route, currentStepIndex, placesOnRoute, handlePlaceCardClick, playedStories]);

    if (!currentStep) {
        return null;
    }

    const icon = maneuverToIcon[currentStep.maneuver] || null;
    const instructionText = currentStep.instructions.split('\n')[0];
    const towardsText = currentStep.instructions.split('\n')[1] || '';


    return (
        <div className="navigation-container">
            {React.createElement(icon, { className: "navigation-icon" })}
            <div className="navigation-text">
                <div className="navigation-instruction">{instructionText}</div>
                {towardsText && <div className="navigation-towards">{towardsText}</div>}
            </div>
        </div>
    );
};

export default Navigation;
